import { render, staticRenderFns } from "./VideoTrimmerDialog.vue?vue&type=template&id=7b8c6b82&scoped=true"
import script from "./VideoTrimmerDialog.vue?vue&type=script&lang=js"
export * from "./VideoTrimmerDialog.vue?vue&type=script&lang=js"
import style0 from "./VideoTrimmerDialog.vue?vue&type=style&index=0&id=7b8c6b82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8c6b82",
  null
  
)

export default component.exports